import React from 'react'
import './footer.css'
import {FaLinkedinIn} from 'react-icons/fa'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'


const Footer = () => {
  return (
    <footer>
      <a href="#" className='footer__logo'>OMAR</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#services">Certificates</a></li> 
        <li><a href="#portfolio">Portfolio</a></li> 
        <li><a href="#contact">Contact</a></li>
      </ul>

      <div className="footer__socials">
        <a href="https://www.linkedin.com/in/omar-alamoudi-9a9265296/"><FaLinkedinIn/></a>
        <a href="https://www.facebook.com/profile.php?id=100090884484185"><FaFacebookF/></a>
        <a href="https://www.instagram.com/omarfrontend/"><FiInstagram/></a>
        <a href="https://twitter.com/omushaeb"><IoLogoTwitter/></a>
      </div>

      <div className="footer__copyright">
        <small>&copy; 2025 OMAR. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
